import { OutlinedButton, FilledButton, TextButton } from '../util/button';

interface RepairRequestButtonFieldProps {
  isEstimating: boolean;
  isInsurance: boolean;
  onClickRepairSelect: () => void;
  onClickAddInsurance: () => void;
  onClickNoRepair: () => void;
}
export const RepairRequestButtonField = ({
  isEstimating,
  isInsurance,
  onClickRepairSelect,
  onClickAddInsurance,
  onClickNoRepair,
}: RepairRequestButtonFieldProps) => {
  return (
    <div className={'estimate-result-button-field'}>
      {isInsurance ? (
        <div className={'button-field with-insurance'}>
          <OutlinedButton onClick={onClickNoRepair} label={'修理しない'} />
          <FilledButton
            onClick={onClickRepairSelect}
            label={'修理依頼に進む'}
            disabled={isEstimating}
          />
        </div>
      ) : (
        <div className={'button-field no-insurance'}>
          <div className={'repair-button-field'}>
            <OutlinedButton
              onClick={onClickAddInsurance}
              label={'保険情報を登録'}
            />
            <FilledButton
              onClick={onClickRepairSelect}
              label={'このまま修理依頼'}
              disabled={isEstimating}
            />
          </div>
          <TextButton onClick={onClickNoRepair} label={'修理しない'} />
        </div>
      )}
    </div>
  );
};
